"use client";

import Script from "next/script";
import { usePathname } from "next/navigation";
import {
  getBitrix24SiteButtonSrc,
  isBitrix24SiteButtonPath,
} from "@/lib/bitrix24/site-button";

/**
 * Виджет поддержки Bitrix24 (site_button).
 * Не загружается на /admin/*.
 */
export function Bitrix24SiteButton() {
  const pathname = usePathname();
  const src = getBitrix24SiteButtonSrc();

  if (!src || !isBitrix24SiteButtonPath(pathname)) return null;

  return (
    <Script id="bitrix24-site-button" strategy="afterInteractive">
      {`(function(w,d,u){
var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/60000|0);
var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);
})(window,document,${JSON.stringify(src)});`}
    </Script>
  );
}
